<template>
  <v-container fluid>
      <v-row>
          <v-col cols="6" sm="6" class="text-left" style="margin: 0 auto;">
              <SelectSeries ref="selectSeries" @presetSelectSerie="presetSelectSerie" />
          </v-col>
      </v-row>
      <SeriesResults />
  </v-container>
</template>

<script>
import SelectSeries from "@/components/series/SelectSeries.vue";
import SeriesResults from "@/components/series/SeriesResults.vue";

export default {
  components: {
      SelectSeries,
      SeriesResults
  },
  methods: {
    presetSelectSerie() {
    }
  }
}
</script>